import React, { useEffect, useState } from "react";
import "../../Dashboard/Dashboard.css";
import "../../Dashboard/Sidebar.js";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";
import FileUpload from "../../FileUploads/FileUpload";
import { toast } from "react-toastify";

const BusinessConfig = ({
  history,
  match,
  createSiteInspectionForm,
  documentUploadUrlPublic,
  inspectionCreated,
  inspectionCreatedData,
  getCity,
  getAllCity,
}) => {
  const inputs = {
    lead_id: 0,
    city: "",
    site_name: "",
    site_address: "",
    total_gates: "",
    poc_name: "",
    poc_number: "",
    poc_designation: "",
    barrier_make: "",
    barrier_make_other: "",
    amc_scope: "",
    power_available: "",
    keys_available: "",
    readers_make: "",
    remarks: "",
    person_assist: "",
    date_of_purchase: "",
    invoice_copy_path: "",
  };

  const [formData, setData] = useState(inputs);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");

  useEffect(() => {
    if (match.params.id !== undefined) {
      setData({ ...formData, lead_id: match.params.id });
    }
    (async () => {
      setIsLoading(true);
      await inspectionCreated(match.params.id);
      setIsLoading(false);
    })();
  }, [match.params.id]);

  useEffect(() => {
    setData({
      ...formData,
      lead_id: match.params.lead_id,
      city: inspectionCreatedData[0]?.city_name,
      site_name: inspectionCreatedData[0]?.site_name,
      site_address: inspectionCreatedData[0]?.site_address,
      total_gates: inspectionCreatedData[0]?.total_gates,
      poc_name: inspectionCreatedData[0]?.poc_name,
      poc_number: inspectionCreatedData[0]?.poc_number,
      poc_designation: inspectionCreatedData[0]?.poc_designation,
      barrier_make: inspectionCreatedData[0]?.barrier_make,
      barrier_make_other: inspectionCreatedData[0]?.barrier_make_other,
      amc_scope: inspectionCreatedData[0]?.amc_scope,
      power_available: inspectionCreatedData[0]?.power_available,
      keys_available: inspectionCreatedData[0]?.keys_available,
      readers_make: inspectionCreatedData[0]?.readers_make,
      remarks: inspectionCreatedData[0]?.remarks,
      person_assist: inspectionCreatedData[0]?.person_assist,
      date_of_purchase: inspectionCreatedData[0]?.date_of_purchase,
    });
  }, [inspectionCreatedData]);

  useEffect(() => {
    if (inspectionCreatedData.length == 0) {
      console.log("YES");
      (async () => {
        setIsLoading(true);
        await getAllCity();
        setIsLoading(false);
      })();
    }
  }, inspectionCreatedData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    if (
      formData.lead_id == "" ||
      formData.amc_scope == "" ||
      formData.power_available == "" ||
      formData.keys_available == "" ||
      formData.readers_make == "" ||
      formData.remarks == "" ||
      formData.person_assist == ""
    ) {
      toast.error("Please fill all inputs!");
      return;
    } else if (formData.city == "") {
      toast.error("Select City!!");
      return;
    } else if (formData.site_name == "") {
      toast.error("Enter Site Name!!");
      return;
    } else if (formData.site_address == "") {
      toast.error("Enter Site Address!!");
      return;
    } else if (formData.total_gates == "" || formData.total_gates < 0) {
      toast.error("Total Gates missing!!");
      return;
    } else if (formData.poc_name == "") {
      toast.error("POC Name missing!!");
      return;
    } else if (formData.poc_number.length != 10 || formData.poc_number < 0) {
      toast.error("Enter valid POC number!!");
      return;
    } else if (formData.poc_designation == "") {
      toast.error("POC Designation missing!!");
      return;
    } else if (formData.barrier_make == "") {
      if (formData.barrier_make == "FAAC Other") {
        toast.error("Specify FAAC Other for Barrier Make!!");
        return;
      }
      toast.error("Select Barrier from dropdown!!");
      return;
    } else if (formData.date_of_purchase == "") {
      toast.error("Date of purchase missing missing!!");
      return;
    } 
    // else if (formData.invoice_copy_path == "") {
    //   toast.error("Upload Invoice!!");
    //   return;
    // }
     else {
      setIsLoading(true);
      const res = await createSiteInspectionForm(formData);
      if(res==true){
        setIsLoading(true)
        setUserMessage('Inspection Created Successfully')
        setRedirectUrl(`inspection-list/${match.params.lead_id}`)
        setIsSuccessModalOpen(true)
        setIsLoading(false)
      }else{
        setIsLoading(true)
        setUserMessage('Something went wrong')
        setRedirectUrl(`inspection-list/${match.params.lead_id}`)
        setIsFailedModalOpen(true)
        setIsLoading(false)
      }
      console.log("ABCD",res)
      setIsLoading(false);
      // window.location.reload();
    }
  };

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={userMessage}
        url={redirectUrl}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={userMessage}
        countToOpenModal={countToOpenModal}
      />

      {/*<Sidebar/>*/}
      {/* section start  */}
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header
              title={match?.params?.id !== undefined ? "View Lead" : "Add Lead"}
            />

            {/*BODY*/}

            <div className="container-fluid">
              {/*Heading*/}
              <div className="d-sm-flex align-items-center justify-content-between">
                <h1 className="h3 mb-0 text-black-100 hide">
                  Add Site Inspection
                </h1>
              </div>

              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-0 bg-white">
                      <div className="div-com-header"></div>
                      <div className="card-body">
                        <div className="user">
                          <div className="form-group row">
                            <div className="col-md-6 float-field mb-4">
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    city:
                                      e.target.value != ""
                                        ? e.target.value
                                        : "",
                                  });
                                }}
                                required
                              >
                                {inspectionCreatedData.length > 0 ? (
                                  <option value="">{formData.city}</option>
                                ) : (
                                  <>
                                    <option value="">Select...</option>
                                    {getCity.map((elem, ind) => {
                                      console.log();
                                      return (
                                        <option value={elem.id}>
                                          {elem.city_name}
                                        </option>
                                      );
                                    })}
                                  </>
                                )}
                              </select>

                              <label className="large-label float-lb">
                                City
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    site_name: e.target.value,
                                  });
                                }}
                                required
                                value={formData.site_name}
                              />

                              <label className="large-label float-lb">
                                Site Name{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    site_address: e.target.value,
                                  });
                                }}
                                required
                                value={formData.site_address}
                              />

                              <label className="large-label float-lb">
                                Site Address{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="number"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    total_gates: e.target.value,
                                  });
                                }}
                                required
                                value={formData.total_gates}
                              />

                              <label className="large-label float-lb">
                                No. of Gates{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    poc_name: e.target.value,
                                  });
                                }}
                                required
                                value={formData.poc_name}
                              />

                              <label className="large-label float-lb">
                                POC Name{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="number"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    poc_number: e.target.value,
                                  });
                                }}
                                required
                                value={formData.poc_number}
                              />

                              <label className="large-label float-lb">
                                POC Number{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    poc_designation: e.target.value,
                                  });
                                }}
                                required
                                value={formData.poc_designation}
                              />

                              <label className="large-label float-lb">
                                POC Designation{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field mb-4">
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    barrier_make:
                                      e.target.value != ""
                                        ? e.target.value
                                        : "",
                                  });
                                }}
                                required
                              >
                                {inspectionCreatedData.length > 0 ? (
                                  <option value="">
                                    {formData.barrier_make}
                                  </option>
                                ) : (
                                  <>
                                    <option value="">Select...</option>
                                    <option value="Local Vendor">
                                      Local Vendor
                                    </option>
                                    <option value="Telecoma">Telecoma</option>
                                    <option value="Aprimatic">Aprimatic</option>
                                    <option value="Came">Came</option>
                                    <option value="FAAC Hydraullic">
                                      FAAC Hydraullic
                                    </option>
                                    <option value="Cardin">Cardin</option>
                                    <option value="RIB">RIB</option>
                                    <option value="FAAC Other">
                                      FAAC Other
                                    </option>
                                  </>
                                )}
                              </select>

                              <label className="large-label float-lb">
                                Barrier Make
                              </label>
                            </div>
                            {formData.barrier_make == "FAAC Other" && (
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    setData({
                                      ...formData,
                                      barrier_make_other: e.target.value,
                                    });
                                  }}
                                  required
                                  value={formData.barrier_make_other}
                                />

                                <label className="large-label float-lb">
                                  Specify Barrier Make Other{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                            )}
                            <div className="col-md-6 float-field mb-4">
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    amc_scope:
                                      e.target.value != ""
                                        ? e.target.value
                                        : "",
                                  });
                                }}
                                required
                              >
                                {inspectionCreatedData.length > 0 ? (
                                  <option value="">{formData.amc_scope}</option>
                                ) : (
                                  <>
                                    <option value="">Select...</option>
                                    <option value="Comp AMC">Comp AMC</option>
                                    <option value="Non Comp AMC">
                                      Non Comp AMC
                                    </option>
                                    <option value="AMC not in our scope">
                                      AMC not in our scope
                                    </option>
                                  </>
                                )}
                              </select>

                              <label className="large-label float-lb">
                                AMC Scope Check
                              </label>
                            </div>
                            <div className="col-md-6 float-field mb-4">
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    power_available:
                                      e.target.value != ""
                                        ? e.target.value
                                        : "",
                                  });
                                }}
                                required
                              >
                                {inspectionCreatedData.length > 0 ? (
                                  <option value="">
                                    {formData.power_available}
                                  </option>
                                ) : (
                                  <>
                                    <option value="">Select...</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </>
                                )}
                              </select>

                              <label className="large-label float-lb">
                                Power Availability
                              </label>
                            </div>
                            <div className="col-md-6 float-field mb-4">
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    keys_available:
                                      e.target.value != ""
                                        ? e.target.value
                                        : "",
                                  });
                                }}
                                required
                              >
                                {inspectionCreatedData.length > 0 ? (
                                  <option value="">
                                    {formData.keys_available}
                                  </option>
                                ) : (
                                  <>
                                    <option value="">Select...</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </>
                                )}
                              </select>

                              <label className="large-label float-lb">
                                Keys Availability
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    readers_make: e.target.value,
                                  });
                                }}
                                required
                                value={formData.readers_make}
                              />

                              <label className="large-label float-lb">
                                Readers Make{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    person_assist: e.target.value,
                                  });
                                }}
                                required
                                value={formData.person_assist}
                              />

                              <label className="large-label float-lb">
                                Person Assist{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              {inspectionCreatedData.length == 0 ? (
                                <input
                                  type="date"
                                  className="form-control form-control-user"
                                  placeholder=""
                                  onChange={(e) => {
                                    setData({
                                      ...formData,
                                      date_of_purchase: e.target.value,
                                    });
                                  }}
                                  required
                                  value={formData.date_of_purchase}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=""
                                  required
                                  value={formData.date_of_purchase}
                                />
                              )}

                              <label className="large-label float-lb">
                                Date of purchase of Barriers as mentioned in PO
                                copy{" "}
                                <i className="bi bi-asterisk astrick-icon"></i>
                              </label>
                            </div>
                            <div className="col-md-6 float-field ">
                              <textarea
                                className="form-control form-control-user cus-red"
                                placeholder="Remarks *"
                                onChange={(e) => {
                                  setData({
                                    ...formData,
                                    remarks: e.target.value,
                                  });
                                }}
                                required
                                value={formData.remarks}
                              />
                            </div>
                            <div className="col-md-6 float-field ">
                              {inspectionCreatedData.length == 0 ? (
                                <FileUpload
                                  multiple
                                  id={"addAttachment"}
                                  accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
                                  documentUploadUrl={documentUploadUrlPublic}
                                  onChange={(val) =>
                                    setData({
                                      ...formData,
                                      invoice_copy_path: val,
                                    })
                                  }
                                >
                                  Upload Invoice Copy or PO Copy
                                </FileUpload>
                              ) : (
                                inspectionCreatedData[0]?.invoice_copy_path?.map(
                                  (elem, ind) => {
                                    return (
                                      <div key={ind}>
                                        <i className="fas fa-paperclip"></i>
                                        <a href={elem}>{` Attachment ${
                                          ind + 1
                                        }`}</a>
                                      </div>
                                    );
                                  }
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {match?.params?.lead_id !== undefined &&
                 inspectionCreatedData.length == 0 && (
                    <div className="col-sm-12 mt-4">
                      <button className="btn btn-primary btn-user btn-block submit-btn">
                        Submit
                      </button>
                    </div>
                  )}
              </form>
            </div>
          </div>
        </div>

        <BottomMenu />
      </div>
      {/* section ends */}
    </>
  );
};
export default BusinessConfig;
